const MuiLinkOverrides = {
  MuiLink: {
    defaultProps: {
      underline: 'none'
    }
  }
};

export { MuiLinkOverrides };
